interface InputFiles {
    acceptFileType: string
}

export const selectFile = async (options: InputFiles): Promise<FileList> => {
    return new Promise((resolve: (list: FileList) => void, reject: () => void) => {
        const {acceptFileType} = {...options};
        const fileTypes: string = acceptFileType;
        const fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.multiple = false;
        fileInput.accept = fileTypes;
        fileInput.addEventListener('change', function () {
            //@ts-expect-error
            resolve(this.files);
            fileInput.parentNode?.removeChild(fileInput);
        });
        fileInput.addEventListener('error', function () {
            reject();
            fileInput.parentNode?.removeChild(fileInput);
        });
        fileInput.style.display = 'none';
        document.body.appendChild(fileInput);
        fileInput.click();
    });
};
